var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._g({class:["mpx-root-view","host-_1d853680"]},_vm.$listeners),[_c('div',{class:([_vm.themeType ? 'cubeic cubeic-' + _vm.themeType : 'cubeic', _vm.iconClass]),style:(_vm._f("transRpxStyle")([(_vm.iconStyle)])),on:{"tap":(e)=>_vm.__invoke(e, [["onClick"]])}})])
}
var staticRenderFns = []

export { render, staticRenderFns }